"use client";
import { useRouter } from "next/navigation";
import { Select } from "@/components/ui/Select";
import type { CompetitionItem } from "@/lib/api/types";
import { dashboardContent } from "@/lib/content";

/**
 * Switching competitions is a navigation, not local state: the aggregate is fetched on
 * the server and cached there, and the address has to be shareable.
 */
export function CompetitionPicker({
  competitions,
  compId,
  liveId,
  className,
}: {
  competitions: CompetitionItem[];
  compId: number | null;
  liveId: number | null;
  className?: string;
}) {
  const router = useRouter();
  const t = dashboardContent.picker;
  if (competitions.length === 0) return null;

  return (
    <Select
      label={t.aria}
      className={className}
      value={String(compId ?? competitions[0]?.competition_id ?? "")}
      onChange={(value) => router.push(`/dashboard?comp=${value}`)}
      options={competitions.map((c) => ({
        value: String(c.competition_id),
        label: c.competition_name,
        hint: c.competition_id === liveId ? t.current : t.archive,
        live: c.competition_id === liveId,
      }))}
    />
  );
}
